import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.scss?vue&type=style&index=0&id=e49a5d7c&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e49a5d7c"]])

export default __exports__